import styled from "styled-components";
import { Steps } from "antd";

export const StepsWrapper = styled(Steps)`
  .ant-steps-item-title {
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.fontColors.headingColor};
    font-weight: ${props => props.theme.fontWeight.bold};
    line-height: ${props => props.theme.lineHeight.heading};
    font-family: ${props => props.theme.fontFamily.berkeleyStdOldStyle};
    letter-spacing: ${props => props.theme.letterSpacing.timeline};
    width: auto;
    white-space: nowrap;
  }

  .anticon {
    cursor: default;
  }

  .ant-steps-item-content {
    text-align: left !important;
  }

  .ant-steps-item-tail::after {
    background-color: ${props => props.theme.backgroundColor.primaryColor};
  }

  .ant-steps-item-wait > .ant-steps-item-tail::after,
  .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon,
  .ant-steps-item-process > .ant-steps-item-tail::after {
    opacity: 0.2;
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon,
  .ant-steps-item-custom.ant-steps-item-process
    .ant-steps-item-icon
    > .ant-steps-icon,
  .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
    color: ${props => props.theme.colors.primaryColor};
    border-color: ${props => props.theme.border.teal};
  }

  .ant-steps-item-wait > .ant-steps-item-content > .ant-steps-item-title,
  .ant-steps-item-wait {
    border-color: ${props => props.theme.border.teal};
    font-family: ${props => props.theme.fontFamily.berkeleyStdOldStyle};
    letter-spacing: ${props => props.theme.letterSpacing.timeline};
  }

  .ant-steps-item-wait > .ant-steps-item-content > .ant-steps-item-title {
    opacity: ${props => props.theme.backgroundColor.blurOpacity};
  }

  .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title {
    color: ${props => props.theme.fontColors.headingColor};
  }

  .ant-steps-item-content > .ant-steps-item-description {
    color: ${props => props.theme.fontColors.headingColor};
    text-align: left !important;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
  }

  .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
    width: 30px;
    height: 30px;
    font-size: ${props => props.theme.fontSize.h3};
  }

  .ant-steps-item-tail::after {
    height: 2px;
  }

  @media only screen and (max-width: 992px) {
    .ant-steps-item-title {
      white-space: normal !important;
      text-align: left !important;
    }
  }
  @media only screen and (max-width: 767px) {
    .ant-steps-item .ant-steps-item-tail::after {
      background-color: ${props => props.theme.backgroundColor.primaryColor};
      width: 2px !important;
    }

    .ant-steps-item-content {
      min-height: 130px !important;
      padding-left: 20px !important;
    }
  }
  @media only screen and (min-width: 768px) {
    .ant-steps-item-tail {
      margin-left: 15px;
    }
    .ant-steps-item-icon {
      margin-left: 0px;
    }
    .ant-steps-vertical > .ant-steps-item > .ant-steps-item-tail::after {
      width: 100%;
      height: 2px;
    }
  }
`;
export const ScheduleDateTooltip = styled.span`
  display: block;
`;
